import { useState, useEffect } from 'react';
import api from '../../hooks/useApi';

// One contractor's contracts, for putting an invoice's days against one.
// Where the contractor has exactly one active contract it is chosen for them,
// and the note under the box says so.
//
// Props:
//   workerId  – the contractor (resource_workers.id); empty shows nothing to pick
//   value     – the chosen contract id
//   onChange  – (contractId) => void
//   className – applied to the <select>
export default function ContractSelect({ workerId, value, onChange, className = 'form-input' }) {
  const [contracts, setContracts] = useState([]);
  const [autoPicked, setAutoPicked] = useState(false);
  const [loadedFor, setLoadedFor] = useState(null);

  useEffect(() => {
    setContracts([]);
    setAutoPicked(false);
    if (!workerId) return;
    let live = true;
    api.get(`resource-workers/${workerId}/contracts`).then(list => {
      if (!live) return;
      setContracts(list || []);
      setLoadedFor(workerId);
      const active = (list || []).filter(c => c.status === 'active');
      if (!value && active.length === 1) { onChange(active[0].id); setAutoPicked(true); }
    }).catch(() => {});
    return () => { live = false; };
  }, [workerId]);

  const chosen = contracts.find(c => c.id === value);
  return (
    <div>
      <select className={className} value={value || ''} disabled={!workerId}
        onChange={e => { onChange(e.target.value); setAutoPicked(false); }}>
        <option value="">{workerId ? '— select contract —' : '— choose the contractor first —'}</option>
        {contracts.map(c => (
          <option key={c.id} value={c.id}>
            {[c.reference, c.sow_reference, c.role_description].filter(Boolean).join(' · ')}
            {c.status !== 'active' ? ` (${c.status})` : ''}
          </option>
        ))}
      </select>
      {workerId && loadedFor === workerId && !contracts.length && (
        <div className="text-[7px] text-amber-700 mt-0.5">⚠ This contractor has no contracts, so the days cannot count against one.</div>
      )}
      {chosen && (
        <div className="text-[7px] text-gray-500 mt-0.5">
          {autoPicked ? '✦ Their only active contract. ' : ''}
          {Number(chosen.invoiced_days || 0)}d invoiced so far
          {chosen.agreed_days != null ? ` of ${Number(chosen.agreed_days)}d agreed` : ''}.
        </div>
      )}
    </div>
  );
}
